// error keys from https://github.com/jusbrasil/network-graphql/blob/7c511c1a22f0abe26653297df4dbd88bb289d50c/src/schema/types/profile/mutations/validate-oab.js#L17
export const ERROR_MESSAGES = {
  DIFFERENT_BIRTHDATE_ERROR: 'A data de nascimento ou o CPF podem estar incorretos',
  DUPLICATED_VALIDATION_ERROR: 'Já existe uma conta com a OAB %s',
  INVALID_CPF: 'A data de nascimento ou o CPF podem estar incorretos',
  INVALID_OAB: 'OAB inválida',
  OAB_NAME_NO_MATCH: 'O nome cadastrado nesta OAB está diferente do nome do CPF informado',

  DEFAULT: 'A OAB não pode ser verificada',
} as const

export type ErrorMessageKey = keyof typeof ERROR_MESSAGES

function isErrorMessageKey(key: string): key is ErrorMessageKey {
  return key in ERROR_MESSAGES
}

export function selectErrorKey(errorKey: string): ErrorMessageKey {
  return isErrorMessageKey(errorKey) ? errorKey : 'DEFAULT'
}
